import { jsxs, jsx } from "react/jsx-runtime";
const IconCategorySvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M9 22H4c-1.103 0-2-.897-2-2v-5c0-1.103.897-2 2-2h5c1.103 0 2 .897 2 2v5c0 1.103-.897 2-2 2Zm-5-7v5h5.002L9 15H4Zm12-4H8a1 1 0 0 1-.868-1.496l4-7c.355-.623 1.38-.623 1.736 0l4 7A1 1 0 0 1 16 11ZM9.724 9h4.552L12 5.016 9.724 9ZM17.5 22c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5 4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5Zm0-7c-1.379 0-2.5 1.121-2.5 2.5s1.121 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.121-2.5-2.5-2.5Z" })
    ]
  }
);
export {
  IconCategorySvg
};
